import Checkbox from '@atlaskit/checkbox';
import { getDatabaseContainerType, useAnalytics } from '@databases/analytics';
import { isModifierKeyPressed } from '@databases/react';
import { defaultStoreUtils } from '@databases/redux';
import {
  selectEntryMulti,
  setSoftSelection,
} from '@databases/redux/cellSelections/actions';
import { useCallback } from 'react';
import React from 'react';

const EntryCheckbox = ({
  contentId,
  entryId,
  isSelected,
  referencing,
}: {
  contentId: string;
  entryId: string;
  isSelected: boolean;
  referencing: boolean;
}) => {
  const analyticsClient = useAnalytics();
  const dispatch = defaultStoreUtils.useDispatch();
  const databaseContainer = getDatabaseContainerType();
  const handleRowCheckboxSelected = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      // Remove focus to prevent focus ring from showing
      e.target.blur();
      const isRangeSelectOn =
        isModifierKeyPressed(e.nativeEvent as MouseEvent | KeyboardEvent, ['shiftKey']) &&
        !isSelected;
      if (!entryId) {
        return;
      }
      analyticsClient.sendRowCheckboxSelectedEvent({
        entryId,
        contentId,
        databaseContainer,
        checkboxState: isSelected ? 'unselected' : 'selected',
      });

      dispatch(
        selectEntryMulti({
          contentId,
          entryId,
          isRangeSelect: isRangeSelectOn,
        })
      );
      dispatch(setSoftSelection({ value: false }));
    },
    [isSelected, entryId, analyticsClient, contentId, databaseContainer, dispatch]
  );

  return (
    <Checkbox
      onChange={handleRowCheckboxSelected}
      isChecked={isSelected}
      isDisabled={referencing}
      tabIndex={-1}
    />
  );
};
export default EntryCheckbox;
